import {createSelector} from 'reselect';

import {ApplePayType} from 'desktop/pages/cart/store/reducers/payments/applePayExpress/applePayExpress';
import {ApplicationStoreType} from 'desktop/store';

/**
 * Get Apple Pay Express data
 *
 * @param {ApplicationStoreType} store - current store
 * @return {ApplePayType} - apple pay data
 */
const getApplePayExpress = (store: ApplicationStoreType): ApplePayType =>
    store.cart.applePayExpress;

/**
 * Get order
 *
 * @param {ApplicationStoreType} store - current store
 * @return {boolean} - payment method is loading
 */
export const getApplePayOrder = createSelector(
    getApplePayExpress,
    applePayExpress => applePayExpress.order,
);
